import React, {useEffect, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import TableRow from './Table-row';
import {t} from 'react-switch-lang';
import uniqid from 'uniqid';
import './table-administration.scss';
import './activeClasses.scss';

const TableAdministration = ({
                               tableHeader,
                               tableRows = [],
                               buttons,
                               fetchMoreData,
                               editableRow,
                               hasMore = false,
                               activeClass,
                               activeRow,
                               smallTable,
                               additional,
                               onRefresh,
                               hasTooltip,
                               scrollThreshold = 0.2,
                             }) => {
  const [tableId] = useState(() => uniqid());
  const [buttonsHoverWidth, setButtonsHoverWidth] = useState(0);
  const [hasDropdown, setHasDropdown] = useState(true);

  const contentColumnPercentWidth = 100 / tableHeader.length;
  const contentColumnStyle = {
    width: `${contentColumnPercentWidth}%`,
    minWidth: `${smallTable === true ? 100 : 150}px`,
  };

  const dropdownButtonWidth = 30;

  const contentsWrapperStyle = {
    width: `calc(100% - ${buttonsHoverWidth}px - ${
      hasDropdown ? dropdownButtonWidth : 0
    }px)`,
    minWidth: `${(smallTable === true ? 100 : 150) * tableHeader.length}px`,
  };

  const rowWrapperMinWidth = `${
    (smallTable === true ? 100 : 150) * tableHeader.length +
    buttonsHoverWidth +
    (hasDropdown ? dropdownButtonWidth : 0) +
    20 +
    20 -
    6
  }px`;

  const getHoverButtonsLength = () => {
    let buttonsHoverLength = 0;

    if (tableRows.length > 0) {
      const buttonsHover = [];

      tableRows.forEach((row) => {
        if (row.buttonsHover !== undefined) {
          const newArr = [];
          row.buttonsHover.forEach((item) => {
            if (item !== undefined && item !== false) {
              newArr.push(item);
            }
          });
          buttonsHover.push(newArr.length);
        }
      });

      buttonsHoverLength = buttonsHover.length > 0 ? Math.max(...buttonsHover) : 0;
    }

    return buttonsHoverLength * 28;
  };

  const findIfHasDropdown = () => {
    let result = false;

    tableRows.forEach((row) => {
      if (row.buttons !== undefined) {
        const hasButton = row.buttons.find(
          (button) => button !== false && button !== undefined
        );
        if (hasButton !== undefined) {
          result = true;
        }
      }
    });

    return result;
  };

  const getHeaderItem = (item) => {
    if (typeof item === 'string') {
      return item;
    }
    if (item?.props) {
      return item.props.children?.[0] ?? '';
    }
    return item ?? '';
  };

  useEffect(() => {
    setButtonsHoverWidth(getHoverButtonsLength());
    setHasDropdown(findIfHasDropdown());
  }, [tableRows]);

  return (
    <div style={{width: '100%', overflow: 'auto'}} className="administration-table-component-container">
      <div
        className="main-row-style header-element"
        style={{
          minWidth: rowWrapperMinWidth,
          width: '100%',
        }}
      >
        <div className="colsTable" style={contentsWrapperStyle}>
          {tableHeader.map((item, index) => (
            <div
              style={contentColumnStyle}
              key={index}
              className={`position-relative table-header-item-container ${
                hasTooltip ? 'hasTooltip' : ''
              } text-truncate`}
            >
              {item}
              {hasTooltip && (
                <span className="table-headers-tooltip">{getHeaderItem(item)}</span>
              )}
            </div>
          ))}
        </div>

        <div style={{width: buttonsHoverWidth, minWidth: buttonsHoverWidth}}> </div>
        <div style={{width: dropdownButtonWidth, minWidth: dropdownButtonWidth}}> </div>
      </div>

      <div
        className="table-administration-container"
        id={tableId}
        style={{
          maxHeight: 'calc(100% - 40px)',
          overflowY: 'auto',
          overflowX: 'visible',
          minWidth: rowWrapperMinWidth,
          width: '100%',
        }}
      >
        <InfiniteScroll
          dataLength={tableRows.length}
          next={fetchMoreData || (() => {})}
          refreshFunction={onRefresh}
          hasMore={hasMore}
          scrollableTarget={tableId}
          scrollThreshold={scrollThreshold}
          loader={<div className="text-center py-2">{t('message.loading')}</div>}
        >
          {tableRows.length > 0 ? (
            tableRows.map((item, index) => (
              <TableRow
                activeRow={activeRow}
                tableRowData={item}
                index={index}
                key={item.id || item.username || index}
                buttons={buttons}
                hide={editableRow}
                rowWrapperStyle={{
                  minWidth: rowWrapperMinWidth,
                  width: '100%',
                }}
                contentsWrapperStyle={contentsWrapperStyle}
                contentColumnStyle={contentColumnStyle}
                buttonsHoverWidth={buttonsHoverWidth}
                activeClass={activeClass}
              />
            ))
          ) : (
            <div className="mx-auto text-center">{t('common.noData')}</div>
          )}

          {additional}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default TableAdministration;